import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { bindPropStore } from "../bindProps";
import { emit, list, text } from "../helpers";
import InlineIcon from "../InlineIcon.svelte";

var root = $.from_html(`<span> </span>`);
var root_1 = $.from_html(`<div class="slex-radio-group-label"><!> <!></div>`);
var root_2 = $.from_html(`<small> </small>`);
var root_3 = $.from_html(`<span class="slex-choice-event-layer"><label class="slex-radio-field"><input type="radio" class="slex-radio"/> <span class="slex-radio-label"><!> <span class="slex-radio-label-text"><span> </span> <!></span></span></label></span>`);
var root_4 = $.from_html(`<div class="slex-radio-group" data-scope="radio-group" data-part="root" role="radiogroup"><!> <div class="slex-radio-group-list"></div></div>`);

export default function RadioGroup($$anchor, $$props) {
	$.push($$props, true);

	let p = $.state($.proxy({}));
	let value = $.state(undefined);
	const lastHapticAt = new Map();

	$.user_effect(() => bindPropStore($$props.props, (next) => {
		$.set(p, next, true);
		$.set(value, next.value, true);
	}));

	function choose(next) {
		$.set(value, next, true);
		emit($$props.ctx, "change", next);
	}

	function vibrate(disabled, duration = 8) {
		if (disabled || $.get(p).haptic === false || $.get(p).haptics === false) return;

		const api = globalThis.navigator;

		if (api?.userActivation?.isActive === false) return;

		api?.vibrate?.(duration);
	}

	function haptic(key, disabled, duration = 8) {
		const now = Date.now();

		if (now - (lastHapticAt.get(key) ?? 0) < 80) return;

		lastHapticAt.set(key, now);
		vibrate(disabled, duration);
	}

	function groupName() {
		return text($.get(p).name ?? $$props.ctx.id, $$props.ctx.id);
	}

	var div = root_4();
	var node = $.child(div);

	{
		var consequent_2 = ($$anchor) => {
			var div_1 = root_1();
			var node_1 = $.child(div_1);

			{
				var consequent = ($$anchor) => {
					InlineIcon($$anchor, {
						get name() {
							return $.get(p).icon;
						},
						className: 'slex-radio-group-icon'
					});
				};

				$.if(node_1, ($$render) => {
					if ($.get(p).icon) $$render(consequent);
				});
			}

			var node_2 = $.sibling(node_1, 2);

			{
				var consequent_1 = ($$anchor) => {
					var span = root();
					var text_1 = $.child(span, true);

					$.reset(span);
					$.template_effect(($0) => $.set_text(text_1, $0), [() => text($.get(p).label)]);
					$.append($$anchor, span);
				};

				$.if(node_2, ($$render) => {
					if ($.get(p).label) $$render(consequent_1);
				});
			}

			$.reset(div_1);
			$.append($$anchor, div_1);
		};

		$.if(node, ($$render) => {
			if ($.get(p).label || $.get(p).icon) $$render(consequent_2);
		});
	}

	var div_2 = $.sibling(node, 2);

	$.each(div_2, 21, () => list($.get(p).options), $.index, ($$anchor, item) => {
		const itemValue = $.derived(() => $.get(item).value ?? $.get(item).label);
		const disabled = $.derived(() => !!$.get(item).disabled || !!$.get(p).disabled);
		const hapticKey = $.derived(() => text($.get(itemValue)));
		var span_1 = root_3();
		var label = $.child(span_1);
		var input = $.child(label);

		$.remove_input_defaults(input);

		var span_2 = $.sibling(input, 2);
		var node_3 = $.child(span_2);

		{
			var consequent_3 = ($$anchor) => {
				{
					let $0 = $.derived(() => $.get(itemValue) === $.get(value));

					InlineIcon($$anchor, {
						get name() {
							return $.get(item).icon;
						},

						get selected() {
							return $.get($0);
						},
						className: 'slex-radio-icon'
					});
				}
			};

			$.if(node_3, ($$render) => {
				if ($.get(item).icon) $$render(consequent_3);
			});
		}

		var span_3 = $.sibling(node_3, 2);
		var span_4 = $.child(span_3);
		var text_2 = $.child(span_4, true);

		$.reset(span_4);

		var node_4 = $.sibling(span_4, 2);

		{
			var consequent_4 = ($$anchor) => {
				var small = root_2();
				var text_3 = $.child(small, true);

				$.reset(small);
				$.template_effect(($0) => $.set_text(text_3, $0), [() => text($.get(item).description)]);
				$.append($$anchor, small);
			};

			$.if(node_4, ($$render) => {
				if ($.get(item).description) $$render(consequent_4);
			});
		}

		$.reset(span_3);
		$.reset(span_2);
		$.reset(label);
		$.reset(span_1);

		$.template_effect(
			($0, $1, $2) => {
				$.set_attribute(label, 'data-disabled', $.get(disabled) ? "true" : undefined);
				$.set_attribute(label, 'data-state', $.get(itemValue) === $.get(value) ? "checked" : "unchecked");
				$.set_attribute(input, 'name', $0);
				$.set_value(input, $1);
				$.set_checked(input, $.get(itemValue) === $.get(value));
				input.disabled = $.get(disabled);
				$.set_attribute(input, 'data-state', $.get(itemValue) === $.get(value) ? "checked" : "unchecked");
				$.set_text(text_2, $2);
			},
			[
				() => groupName(),
				() => text($.get(itemValue)),
				() => text($.get(item).label)
			]
		);

		$.delegated('pointerdown', span_1, () => haptic($.get(hapticKey), $.get(disabled), 8));
		$.delegated('click', span_1, () => haptic($.get(hapticKey), $.get(disabled), 8));
		$.delegated('change', input, () => choose($.get(itemValue)));
		$.append($$anchor, span_1);
	});

	$.reset(div_2);
	$.reset(div);

	$.template_effect(
		($0, $1, $2) => {
			$.set_attribute(div, 'data-orientation', $0);
			$.set_attribute(div, 'data-variant', $1);
			$.set_attribute(div, 'aria-label', $2);
		},
		[
			() => text($.get(p).orientation, "vertical"),
			() => text($.get(p).variant ?? $.get(p).presentation) || undefined,
			() => text($.get(p)["aria-label"] ?? $.get(p).ariaLabel ?? $.get(p).label) || undefined
		]
	);

	$.append($$anchor, div);
	$.pop();
}

$.delegate(['pointerdown', 'click', 'change']);